import { Box } from '@cad-arc';
import { BoloPanelTabs } from './tabs/bolo-panel-tabs';
import { useBoloPanelMetadata } from '../state/bolo-panel-metadata-context';
import { BoloAdditionalInfos } from '../additional-infos/bolo-additional-infos';
import { observer } from 'mobx-react-lite';

export const BoloPanelRightPane = observer(() => {
    const metadata = useBoloPanelMetadata();

    return (
        <Box w="500px" h="100%" flexGrow={10000}>
            {metadata?.boloId ? <BoloAdditionalInfos /> : <BoloPanelTabs mode="FULL" />}
        </Box>
    );
});
